export { HistoricalStatisticsPanel } from "./historical-statistics-panel";
